import { useCallback, useRef } from 'react';

export default function useScrollableSections<T extends string>() {
  const sectionsRefs = useRef({} as Record<T, HTMLElement>);

  const setRef = useCallback(
    (sectionTitle: T) => (block: HTMLElement | null) => {
      if (block) {
        sectionsRefs.current[sectionTitle] = block;
      }
      return block;
    },
    []
  );

  const scrollToSection = useCallback((section: T) => {
    sectionsRefs.current[section]?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, []);

  return {
    setRef,
    scrollToSection,
  };
}
